const attaches = (param) => {
    //console.log(param)
    return `<div class="block-fileDownload">
                <div class="block-fileDownload__wrapper">
                    <div>
                        <a href="${param.data.file.url}" class="block-fileDownload__view" target="_blank">
                            ${param.data.title ? param.data.title : param.data.file.name}
                        </a>
                    </div>
                    <div>
                        <a href="${param.data.file.url}" class="block-fileDownload__download" download></a>
                    </div>
                </div>
            </div>`
}
module.exports = attaches;
